import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { Redirect } from "react-router-dom";
import * as authActions from '../../redux/modules/auth';
import * as instrumentListActions from '../../actions/instrumentListActions';
import * as commonActions from '../../actions/commonActions';
import ChangePasswordComponent from '../ChangePassword/ChangePasswordComponent';
import styles from './Login.less';
import config from '../../config';
import moment from 'moment';
import ForgotPassword from '../ForgotPassword/ForgotPassword';
import { bindActionCreators } from 'redux';
import Modal from 'react-modal';
import MUIIcon from '../../components/IconMaterialUI/MUIIcon';
import MUIIconWithTooltip from '../../components/IconMaterialUI/MUIIconWithTooltip';
import i18next from 'i18next';
import { setContrastTextColor } from '../../utils/utils';

class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loadtableflag: true,
      userData: this.getInitialUserData(''),
      loginStatus: false,
      isSessionExp: false,
      loginErrFlag: false,
      loginErrMsg: "",
      locationMap: [],
      showForgotPass: false,
      resetPassToday: false
    }
    if (localStorage.userlogin === 'true') {
      this.props.history.push("/session_expired");
    } else {
      var url = window.location.hostname === "localhost" ? config.host : window.location.hostname;
      this.props.getConfigInfo();
    }

    this.onBackButtonEventLogin = this.onBackButtonEventLogin.bind(this);
    this.loginUser = this.loginUser.bind(this);
  }

  componentWillMount() {
    const env = this.props.configInfo && this.props.configInfo.isProd === false ? 'dev' : 'production';
    fetch(`https://neox-asset.neofinancials.com/ntp/${env}/properties/LocationMap.json`)
      .then(response => response.json())
      .then(data => {
        this.setState({ locationMap: data });
      })
  }

  componentDidMount() {
    if (localStorage.userlogin !== "true") {
      this.props.resetStateSocket();
      localStorage.socketData = [];
      window.addEventListener("popstate", this.onBackButtonEventLogin);
    }
    setTimeout(() => this.setState({ loadtableflag: false }), 3000);
  }

  componentDidUpdate(prevProps) {
    // set dynamic color for forgot pass link
    const forgotLinkTextID = "forgotPasswordLink"
    const loginBackgroundImgID = "loginBackground"
    setContrastTextColor(forgotLinkTextID, loginBackgroundImgID, styles.forgotLink, styles.forgotLinkLight);

    if (
    this.props.configInfo &&
    this.props.configInfo.location &&
    prevProps.configInfo.location !== this.props.configInfo.location
    ) {
      const LOCATION = this.props.configInfo.locationDesc;
      const env = this.props.configInfo.isProd === false ? 'dev' : 'production';
      const faviconUrl = `https://neox-asset.neofinancials.com/ntp/${env}/${LOCATION}/favicon.png`;

      let link = document.querySelector("link[rel*='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'shortcut icon';
        document.head.appendChild(link);
      }
      link.href = faviconUrl;
    }
  }

  getInitialUserData(location) {
    try{
      return {
        name: '',
        password: '',
        //*************NOTE:Take 'location' from process environment config properties****************
        location: location,
        //*********************************************************************************************
        forcedLogin: true
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'getInitialUserData', component:"Login"});
    }
  }

  onBackButtonEventLogin = (e) => {
    try{
      e.preventDefault();
      this.props.resetpass_flag();
      if (this.props.showRP)
      localStorage.userlogin = null;
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onBackButtonEventLogin', component:"Login"});
    }
  }

  oncloseModal = () => {
    try{
      this.props.closeForceLogout();
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'oncloseModal', component:"Login"});
    }
  }

  //Update username in state
  usernameChangeHandler = (event) => {
    try{
      let userData = { ...this.state.userData };
      userData.name = event.target.value;
      this.setState({ userData: userData });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'usernameChangeHandler', component:"Login"});
    }
  }

  //update password in state
  passwordChangeHandler = (event) => {
    try{
      let userData = { ...this.state.userData };
      userData.password = event.target.value;
      this.setState({ userData: userData });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'passwordChangeHandler', component:"Login"});
    }
  }

  compcodeChangeHandler = (event) => {
    try{
      let userData = { ...this.state.userData };
      userData.location = event.target.value.toUpperCase();
      this.setState({ userData: userData });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'compcodeChangeHandler', component:"Login"});
    }
  }

  componentWillReceiveProps(nextProps, nextState) {
    if (this.props.configInfo !== nextProps.configInfo) {
      var location = nextProps.configInfo.showTrdCompanyCode == true ? '' : nextProps.configInfo.location;
      this.setState({ userData: this.getInitialUserData(location) });
      document.title = nextProps.configInfo.trdTitle;
    }
    if (this.props.errorMsg !== nextProps.errorMsg) {
      this.setState({ loginErrMsg: nextProps.errorMsg })
      if (nextProps.errorMsg !== '' && nextProps.errorMsg !== 'Login Succesful' && this.state.showForgotPass === false) {
        this.setState({ loginErrFlag: true })
      }
    }
    this.setState({ loginStatus: nextProps.loginStatus });
  }

  //Login button click event
  handleSubmit = (event) => {
    try{
      event.preventDefault();
      this.setState({ isSessionExp: false });
      if (localStorage.getItem("userlogin") === null || localStorage.getItem("userlogin") === "null" ||
        localStorage.getItem("userlogin") !== "true") {
        let userData = { ...this.state.userData };
        if (this.props.configInfo.showTrdCompanyCode === false) {
          userData.location = this.props.configInfo.location;
        }
        if (userData.name === '') {
          this.setState({ loginErrFlag: true });
          this.setState({ loginErrMsg: 'Username Should Not Be Blank' });
        } else if (userData.password === '') {
          this.setState({ loginErrFlag: true });
          this.setState({ loginErrMsg: 'Password Should Not Be Blank' });
        } else if (this.props.configInfo.showTrdCompanyCode && userData.location === '') {
          this.setState({ loginErrFlag: true });
          this.setState({ loginErrMsg: 'Company Code Should Not Be Blank' });
        } else {
          let flag = 0;
          if (this.props.configInfo.showTrdCompanyCode === true) {
            for (let i = 0; i < this.state.locationMap.length; i++) {
              if (this.state.locationMap[i].DESC === userData['location'].toUpperCase()) {
                userData.location = this.state.locationMap[i].CODE;
                userData.locationDesc = this.state.locationMap[i].DESC;
                flag = 1;
                break;
              }
            }
          }
          if (flag == 0 && this.props.configInfo.showTrdCompanyCode !== false) {
            userData.location = "";
            userData.locationDesc = "";
          }
          if (this.props.configInfo !== '') {
            this.setState({
              loginStatus: true,
              loginErrFlag: false,
              loginErrMsg: ''
            })
            this.loginUser(userData);
          } else {
            this.setState({
              loginStatus: false,
              loginErrFlag: true,
              loginErrMsg: 'Service unavailable now. Please try again later.'
            })
          }
        }
      } else {
        this.setState({ isSessionExp: true });
        return <Redirect to="/session_expired" />
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'handleSubmit', component:"Login"});
    }
  }

  //Forced Login click event
  forcedLogin = (event) => {
    try{
      event.preventDefault();
      this.setState({ loginStatus: true });
      this.loginUser(this.state.userData);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'forcedLogin', component:"Login"});
    }
  }

  //Log in the user
  loginUser = (userData) => {
    try{
      if (localStorage.userlogin !== 'true') {
        this.props.login(userData);
        this.props.resetUnlockState();
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'loginUser', component:"Login"});
    }
  }

  //hidePassWordExpirationMsg
  hidePassswordExpiryMsg = () => {
    this.props.hidePassswordExpPopup()
  }
  
  resetLater = () => {
    if(this.state.resetPassToday){
      this.props.hidePassswordExpPopup()
    }
    localStorage.setItem('userlogin', 'true');
    this.props.history.push("/home");
  }

  closePassExpModal = () => {
    localStorage.setItem('userlogin', 'true');
    this.props.history.push("/home");
  }

  resetNow = () => { 
    this.props.handleResetPwdStatus()
  }

  passwordExpiryCheckboxHandler = () => {
    this.setState({ resetPassToday: !this.state.resetPassToday })
  }

  handleForgotPass = () => {
    try{
      if (this.props.configInfo !== '') {
        this.setState({ showForgotPass: true, loginErrFlag: false })
      } else {
        this.setState({
          showForgotPass: false,
          loginErrFlag: true,
          loginErrMsg: 'Service unavailable now. Please try again later.'
        })
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'handleForgotPass', component:"Login"});
    }
  }

  //Render the login html
  renderLoginHtml = (userLoggedIn) => {
    try{
      return (
        <div className={`${styles.loginPage} container animated fadeInDown`}>
  
          <Helmet title={this.props.configInfo.trdTitle} />
  
          <div>
            <div className={styles.loginContainer}>
              <div className={styles.formWrap}>
                <div className={styles.formContainer}>
                  <div className={`${styles.paraDiv} col-md-12`}>
                    {this.state.loginErrFlag === true && this.state.loginErrMsg !== '' &&
                      <p className={styles.alertError}>
                        <MUIIcon icon={"Error"}/>
                        <span>{this.state.loginErrMsg}</span>
                      </p>
                    }
                  </div>
  
                  {(navigator.userAgent.indexOf('Trident') != -1 || navigator.userAgent.indexOf('MSIE') != -1) ?
                    <div className={styles.ieNoSupport}>Internet Explorer is no longer a supported browser. Please access the application on Chrome, Firefox, Edge or Safari browsers.</div>
  
                    : this.props.showRP === true || this.props.resetPasswordStatus === 'initiated' ?
                      <ChangePasswordComponent />
                      : this.props.ShowPwdExpMsg === true && this.props.showRP === false ?
                          this.renderPasswordExpiryPopup()
                      : this.state.showForgotPass ?
                        <ForgotPassword onClose={() => this.setState({ showForgotPass: false })} />
                        :
                        <form className="login-form" onSubmit={this.handleSubmit}>
                          <div className="form-group">
                            <input type="text" autoFocus
                              value={this.state.userData["name"]}
                              placeholder="Username" maxLength="20"
                              className={`${styles.username} form-control`} onChange={this.usernameChangeHandler}
                            />
  
                            <input type="password" value={this.state.userData["password"]}
                              placeholder="Password" maxLength="50"
                              className={this.props.configInfo.showTrdCompanyCode !== undefined &&
                                this.props.configInfo.showTrdCompanyCode === true ? "form-control" : `${styles.password} form-control`}
                              onChange={this.passwordChangeHandler}
                            />
  
                            {(this.props.configInfo.showTrdCompanyCode !== undefined && this.props.configInfo.showTrdCompanyCode === true) &&
                              <input type="text" value={this.state.userData["location"]}
                                placeholder="Company code" maxLength="10"
                                className={`${styles.password} form-control`} onChange={this.compcodeChangeHandler}
                              />
                            }

                            <div className={`${styles.btnDiv}`}>
                              {this.state.loginStatus === false ? <button type="submit">LOGIN</button> : <button type="button"><img src="/images/loader.gif" /></button>}
                            </div>

                            <button id="forgotPasswordLink" type='button' className={`${styles.forgotLink}`} onClick={() => this.handleForgotPass()}>Forgot Password?</button>
                          </div>
                        </form>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'renderLoginHtml', component:"Login"});
    }
  }

  //Render the loader before login page appears
  renderLoginLoader = () => {
    try{
      return (
        <div className={styles.loaderWrpr}>
          <div className="loginLoader">
            <img src="/images/loader.gif" />
          </div>
        </div>
      )
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'renderLoginLoader', component:"Login"});
    }
  }

  //Render PasswordExpiry PopUp
  renderPasswordExpiryPopup = () => {
    const closeIcon =  <MUIIconWithTooltip icon={'Close'} className={`${styles.icon}`} title={i18next.t("close")} style={{color:'black', marginBottom: '3.5px', fontSize:'16px'}}/>
    return (
      <Modal isOpen={this.props.ShowPwdExpMsg} className={styles.passwordExpiryAlertContainer} overlayClassName="overlay" contentLabel="Alert"  >
        <div ref="errorMSG" className={`${styles.passwordExpiryAlertContainerwrap}`}>
          <div className={`${styles.passwordExpiryAlertHeader} header`}>
            <span className={`${styles.msgTitle}`}>Alert</span>
            <span className={`${styles.passwordExpiryAlertCancelIconContainer} closeIcon`} onClick={() => this.closePassExpModal()} >{closeIcon}</span>
          </div>

          <div className={`${styles.passwordExpiryAlertMsg}`}>
            <span>{`Your password will expire in ${this.props.PwdExpCount}. Do you want to reset your password now? `} </span>
            <div className={`${styles.passwordExpiryAlertMsgCheckboxHolder}`}>
              <input type='checkbox' id='passwordExpiryCheckbox' value={this.state.resetPassToday} onChange={() => this.passwordExpiryCheckboxHandler()} />
              <span> Don't show this message again today.</span>
            </div>
            <div className={`${styles.passwordExpiryAlertButtonHolder}`}>
              <button onClick={() => this.resetNow()} disabled={this.state.resetPassToday}>Reset Now</button>
              <button onClick={() => this.resetLater()}>Reset Later</button>
            </div>
          </div>
        </div>
      </Modal>
    )
  }

  render() {
    let userLoggedIn;
    if (localStorage.getItem("user") !== null && localStorage.getItem("user") !== 'null' && !this.state.isSessionExp) {
      const { userSession } = this.props;
      userLoggedIn = localStorage.getItem("user").SID;
      if (this.props.logoutSuccess) {
        userLoggedIn = null;
      }
      if (localStorage.getItem('userlogin') === 'null') {
        userLoggedIn = null;
      }
      if (userLoggedIn !== null) {
        if (this.props.showRP === false && this.props.ShowPwdExpMsg === false) {
          //localStorage.TS=JSON.stringify(this.props.TS);
          return <Redirect to="/home" />
        } else {
          // localStorage.TS=JSON.stringify(this.props.TS);
        }
      }
    }

    const LOCATION = this.props.configInfo.locationDesc;
    const env = this.props.configInfo.isProd === false ? 'dev' : 'production';
    let logo = `https://neox-asset.neofinancials.com/ntp/${env}/${LOCATION}/logo.png`;
    let bgUrl = `https://neox-asset.neofinancials.com/ntp/${env}/${LOCATION}/bg.jpg`;

    // Set dynamic background image for loginBody
    const loginBodyStyle = {
      backgroundImage: `url('${bgUrl}')`,
      backgroundPosition: '50%',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      margin: 0,
      width: '100%',
      padding: 0,
      position: 'relative',
      display: 'block',
      height: '77vh',
      borderWidth: '4px 0',
      borderStyle: 'solid',
      borderImage: 'linear-gradient(to left, #ca9030, #f3da70, #ca9030) 1 0 100%',
    };

    return (
      <div>
        <div className={styles.headerWrap}>
          <div className={styles.logoWrap}>
            {this.props.configInfo.showLogoOnLogin !== undefined && this.props.configInfo.showLogoOnLogin === true &&
              <img height="80px" src={logo} />
            }
          </div>
        </div>

        <div id="loginBackground" className={styles.loginBody} style={loginBodyStyle}>
          {/*<img src="/images/bg.jpg?123" height="82px" />*/}
          {!this.state.loadtableflag ? this.renderLoginHtml(userLoggedIn) : this.renderLoginLoader()}
        </div>

        <div className={`${styles.footerDiv}`}>
          <div>{this.props.configInfo.footerAddrOne} </div>
          <div>{this.props.configInfo.footerAddrTwo}</div>
          <div>{this.props.configInfo.footerAddrThree} </div>
          <div>{this.props.configInfo.websiteText} <a href={this.props.configInfo.websiteURL} target="_blank">{this.props.configInfo.website}</a> {this.props.configInfo.extraText}</div>
          <div className={`${styles.hrLine}`}></div>
          {this.props.configInfo.showCopyright === true ?
            <span className={`${styles.copyright}`}>Copyright © {moment().format('YYYY')} | All rights reserved, <a href="http://www.orosoft.com" target="_blank">www.orosoft.com</a>. Powered by NEO Financials.</span>
            : null}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userSession: state.auth.userSession,
    logoutSuccess: state.auth.logoutSuccess,
    errorMsg: state.auth.errorMsg,
    loginStatus: state.auth.loginStatus,
    changePassword: state.auth.changePassword,
    loggingIn: state.auth.loggingIn,
    selectedTheme: state.auth.selectedTheme,
    //forcedLogin:state.auth.forcedLogin,
    //forcepwd:state.auth.forcepwd,
    configInfo: state.auth.configInfo,
    showRP: state.auth.showRP,
    ShowPwdExpMsg: state.auth.ShowPwdExpMsg,
    PwdExpCount: state.auth.PwdExpCount,
    resetPasswordStatus: state.auth.resetPasswordStatus,
  };
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    login: authActions.login,
    resetpass_flag: authActions.resetpass_flag,
    closeForceLogout: authActions.closeForceLogout,
    getConfigInfo: authActions.getConfigInfo,
    resetStateSocket: instrumentListActions.resetStateSocket,
    resetUnlockState: commonActions.resetUnlockState,
    hidePassswordExpPopup: authActions.hidePassswordExpPopup,
    handleResetPwdStatus: authActions.handleResetPwdStatus,
    logFileCreation: commonActions.logFileCreation,
  }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);


